export default __webpack_public_path__ + "static/media/2024-oftalmologie-2.9eb5e2cb.jpg";